import { format } from '@/components/controllers/FormatController.js'

export default {
    state: {
        profileFields: {
            isEditing: false,
            profileIsLoading: false,
            buttonEdit: {
                display: '',
                action: null,
                fill: true
            },
            buttonCancel: {
                display: 'Cancelar',
                outlined: true
            },
            personalData: [
                {
                    display: 'Nome',
                    type: 'text',
                    value: '',
                    valueBkp: '',
                    required: true,
                    editable: true,
                    maxlength: 50
                },
                {
                    display: 'CPF',
                    type: 'text',
                    value: '',
                    valueBkp: '',
                    format: 'cpf',
                    required: true,
                    editable: false
                },
                {
                    display: 'E-mail',
                    type: 'email',
                    value: '',
                    valueBkp: '',
                    format: 'email',
                    required: true,
                    editable: true,
                    maxlength: 50
                },
                {
                    display: 'Celular',
                    type: 'text',
                    value: '',
                    valueBkp: '',
                    format: 'cellNumber',
                    required: true,
                    editable: true
                },
                {
                    display: 'Receber e-mail quando o saldo de algum cartão for inferior a:',
                    type: 'number',
                    value: '',
                    valueBkp: '',
                    format: 'currency',
                    required: false,
                    editable: true,
                    maxlength: 12
                }
            ],
            checkboxes: [
                {
                    display: 'Desejo receber e-mails do aplicativo',
                    type: 'checkbox',
                    id: 'check_email',
                    value: false,
                    valueBkp: ''
                },
                {
                    display: 'Desejo receber notificações do aplicativo',
                    type: 'checkbox',
                    id: 'check_notificacao',
                    value: false,
                    valueBkp: ''
                },
                {
                    display: 'Este usuário é o responsável financeiro de todos os dependentes cadastrados',
                    type: 'checkbox',
                    id: 'check_resp_financeiro',
                    value: true,
                    valueBkp: ''
                }
            ],
            addressData: [
                {
                    display: 'Endereço',
                    type: 'text',
                    value: '',
                    valueBkp: '',
                    required: true,
                    editable: true,
                    maxlength: 50
                },
                {
                    display: 'CEP',
                    type: 'number',
                    value: '',
                    valueBkp: '',
                    format: 'cep',
                    required: true,
                    editable: true
                },
                {
                    display: 'Número',
                    type: 'number',
                    value: '',
                    valueBkp: '',
                    required: true,
                    editable: true,
                    maxlength: 5
                },
                {
                    display: 'Complemento',
                    type: 'text',
                    value: '',
                    valueBkp: '',
                    required: false,
                    editable: true,
                    maxlength: 100
                },
                {
                    display: 'Referência',
                    type: 'text',
                    value: '',
                    valueBkp: '',
                    required: false,
                    editable: true,
                    maxlength: 100
                },
                {
                    display: 'UF',
                    type: 'select',
                    value: '',
                    valueBkp: '',
                    required: true
                },
                {
                    display: 'Município',
                    type: 'select',
                    value: '',
                    valueBkp: '',
                    code: '',
                    codeBkp: '',
                    required: true
                },
                {
                    display: 'Bairro',
                    type: 'text',
                    value: '',
                    valueBkp: '',
                    required: true,
                    editable: true,
                    maxlength: 100
                }
            ],
            integrationData: {
                fields: []
            }
        }
    },
    mutations: {
        startEditing (state, data) {
            state.profileFields.isEditing = true
            state.profileFields.buttonEdit.display = 'Confirmar'
            state.profileFields.buttonEdit.action = data.action
        },
        saveBackupData (state) {
            if (state?.profileFields?.personalData?.length > 0) {
                state.profileFields.personalData.forEach(field => {
                    field.valueBkp = field.value
                })
            }

            if (state?.profileFields?.checkboxes?.length > 0) {
                state.profileFields.checkboxes.forEach(checkbox => {
                    checkbox.valueBkp = checkbox.value
                })
            }

            if (state?.profileFields?.addressData?.length > 0) {
                state.profileFields.addressData.forEach(field => {
                    field.valueBkp = field.value
                    if (field.code !== undefined) field.codeBkp = field.code
                })
            }

            if (state?.profileFields?.integrationData?.checkbox?.length > 0) {
                state.profileFields.integrationData.checkbox.forEach(checkbox => {
                    checkbox.valueBkp = checkbox.value
                })
            }

            if (state?.profileFields?.integrationData?.fields?.length > 0) {
                state.profileFields.integrationData.fields.forEach(field => {
                    field.valueBkp = field.value
                })
            }
        },
        restoreBackupData (state) {
            if (state?.profileFields?.personalData?.length > 0) {
                state.profileFields.personalData.forEach(field => {
                    field.value = field.valueBkp
                })
            }

            if (state?.profileFields?.checkboxes?.length > 0) {
                state.profileFields.checkboxes.forEach(checkbox => {
                    checkbox.value = checkbox.valueBkp
                })
            }

            if (state?.profileFields?.addressData?.length > 0) {
                state.profileFields.addressData.forEach(field => {
                    field.value = field.valueBkp
                    if (field.code !== undefined) field.code = field.codeBkp
                })
            }

            if (state?.profileFields?.integrationData?.checkbox?.length > 0) {
                state.profileFields.integrationData.checkbox.forEach(checkbox => {
                    checkbox.value = checkbox.valueBkp
                })
            }

            if (state?.profileFields?.integrationData?.fields?.length > 0) {
                state.profileFields.integrationData.fields.forEach(field => {
                    field.value = field.valueBkp
                })
            }
        },
        stopEditing (state, data) {
            state.profileFields.isEditing = false
            state.profileFields.buttonEdit.display = 'Editar'
            state.profileFields.buttonEdit.action = data.action
        },
        setProfileFields (state, data) {
            state.profileFields.personalData[0].value = data.NMRESPCONS ? format(data.NMRESPCONS, state.profileFields.personalData[0].format) : ''
            state.profileFields.personalData[1].value = data.NRCPFRESPCON ? format(data.NRCPFRESPCON, state.profileFields.personalData[1].format) : ''
            state.profileFields.personalData[2].value = data.DSEMAILCONS ? format(data.DSEMAILCONS, state.profileFields.personalData[2].format) : ''
            state.profileFields.personalData[3].value = data.NRCELULARCONS ? format(data.NRCELULARCONS, state.profileFields.personalData[3].format) : ''

            try {
                state.profileFields.personalData[4].value =
                    data.sonsNotifValues[0].VRNOTIFSALDO ? format(data.sonsNotifValues[0].VRNOTIFSALDO, state.profileFields.personalData[4].format) : ''
            } catch (error) {
                state.profileFields.personalData[4].value = ''
            }

            state.profileFields.addressData[0].value = data.DSENDECONS ? format(data.DSENDECONS, state.profileFields.addressData[0].format) : ''
            state.profileFields.addressData[1].value = data.NRCEPCONS ? format(data.NRCEPCONS, state.profileFields.addressData[1].format) : ''
            state.profileFields.addressData[2].value = data.NRENDECONS ? format(data.NRENDECONS, state.profileFields.addressData[2].format) : ''
            state.profileFields.addressData[3].value = data.DSCOMPLENDECONS ? format(data.DSCOMPLENDECONS, state.profileFields.addressData[3].format) : ''
            state.profileFields.addressData[4].value = data.DSREFERENDECONS ? format(data.DSREFERENDECONS, state.profileFields.addressData[4].format) : ''
            state.profileFields.addressData[5].value = data.SGESTADO ? format(data.SGESTADO, state.profileFields.addressData[5].format) : ''
            state.profileFields.addressData[6].value = data.NMMUNICIPIO ? format(data.NMMUNICIPIO, state.profileFields.addressData[6].format) : ''
            state.profileFields.addressData[7].value = data.NMBAIRCONS ? format(data.NMBAIRCONS, state.profileFields.addressData[7].format) : ''
            state.profileFields.addressData[6].code = data.CDMUNICIPIO || ''

            state.profileFields.integrationData.fields = []
            data.childrenPhones.forEach(child => {
                state.profileFields.integrationData.fields.push({
                    type: 'text',
                    format: 'cellNumber',
                    display: child.NMCONSUMIDOR,
                    consumer: child.CDCONSUMIDOR,
                    value: child.PHONE ? format(child.PHONE, 'cellNumber') : '',
                    valueBkp: '',
                    required: false
                })
            })

            state.profileFields.checkboxes[0].value = data.HABENVEMAIL === 'S'
            state.profileFields.checkboxes[1].value = data.HABENVNOTIF === 'S'
        },
        setUfData (state, data) {
            state.profileFields.addressData[5].value = data.SGESTADO || ''
            state.profileFields.addressData[6].value = ''
            state.profileFields.addressData[6].code = ''
            state.profileFields.addressData[7].value = ''
        },
        setCityData (state, data) {
            state.profileFields.addressData[6].value = data.NMMUNICIPIO || ''
            state.profileFields.addressData[6].code = data.CDMUNICIPIO || ''
            state.profileFields.addressData[7].value = ''
        },
        startLoading (state) {
            state.profileFields.profileIsLoading = true
        },
        stopLoading (state) {
            state.profileFields.profileIsLoading = false
        }
    },
    actions: {
        setProfileFields ({ commit }, data) {
            commit('setProfileFields', data)
        },
        setUfData ({ commit }, data) {
            commit('setUfData', data)
        },
        setCityData ({ commit }, data) {
            commit('setCityData', data)
        },
        startEditing ({ commit }, data) {
            commit('startEditing', data)
        },
        stopEditing ({ commit }, data) {
            commit('stopEditing', data)
        },
        startLoading ({ commit }) {
            commit('startLoading')
        },
        stopLoading ({ commit }) {
            commit('stopLoading')
        },
        saveBackupData ({ commit }) {
            commit('saveBackupData')
        },
        restoreBackupData ({ commit }) {
            commit('restoreBackupData')
        }
    },
    getters: {
        profileFields: (state) => state.profileFields,
        isEditing: (state) => state.profileFields.isEditing,
        profileIsLoading: (state) => state.profileFields.profileIsLoading,
        buttonEdit: (state) => state.profileFields.buttonEdit,
        buttonCancel: (state) => state.profileFields.buttonCancel,
        getUfData: (state) => {
            return {
                SGESTADO: state.profileFields.addressData[5].value
            }
        },
        isFinancialResponsible: (state) => state.profileFields.checkboxes[2].value
    }
}
